// Module
var code = "<div class=\"content\"><slot></slot></div>";
// Exports
module.exports = code;